import type { UserInfo } from 'node:os';

export const formatVolume = (number: number) => {
	const suffixes = ['', 'K', 'M', 'B', 'T']; // Add more suffixes as needed

	let suffixIndex = 0;

	while (number >= 1000 && suffixIndex < suffixes.length - 1) {
		number /= 1000;
		suffixIndex++;
	}

	return number.toFixed(1) + suffixes[suffixIndex];
};

export const getDayName = (dayOfWeek: number) => {
	const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	return days[dayOfWeek - 1];
};

export const USDollar = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

export const isPROUser = (user: Record<string, string | number>): Boolean => {
	return user?.plan === 1;
};

export const capitalizeFirstLetter = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const convertTextToIntAiDecision = (str: string) => {
	return str === 'buy' ? 2.5 : str === 'sell' ? 0.5 : 1.5;
};

export const formatSchedule = (schedule) => {
	const days = ['M', 'T', 'W', 'Th', 'F', 'S', 'Su'];
	let formattedSchedule = '';

	schedule.forEach((day) => {
		const dayOfWeek = days[day.day_of_week - 1];
		const status = day.active ? `${day.from}-${day.to}` : 'OFF';

		formattedSchedule += `${dayOfWeek}: ${status}, `;
	});

	// Remove the trailing comma and space
	formattedSchedule = formattedSchedule.slice(0, -2);

	return formattedSchedule;
};
